// the values here are localization keys
export enum OptionsKeys {
    Text = 'aumico_notes_text',
    Title = 'aumico_notes_title',
    Selection_Option = 'aumico_notes_component_options_selection_option',
    Total_Row = 'aumico_notes_total_row',
    Text_Title = 'aumico_notes_component_options_text_title',
    Current_Value_Title_1 = 'aumico_notes_component_options_current_value_title_1',
    Current_Value_Title_2 = 'aumico_notes_component_options_current_value_title_2',
    Previous_Value_Title_1 = 'aumico_notes_component_options_previous_value_title_1',
    Previous_Value_Title_2 = 'aumico_notes_component_options_previous_value_title_2',
    Movements_Schedule_Column1 = 'aumico_notes_component_options_movementschedule_column1',
    Movements_Schedule_Column2 = 'aumico_notes_component_options_movementschedule_column2',
    Movements_Schedule_Column3 = 'aumico_notes_component_options_movementschedule_column3',
    Movements_Schedule_Column4 = 'aumico_notes_component_options_movementschedule_column4',
    Compare_Years = 'aumico_notes_input_options_compare_years',
    Data_Type = 'aumico_notes_input_options_data_type',
    Number_of_Decimal_places = 'aumico_notes_input_options_number_of_decimal_places',
    Use_As_Parameter = 'aumico_notes_input_options_use_as_parameter',
    Parameter_Name = 'aumico_notes_input_options_parameter_name',
}
